<mat-expansion-panel
  class="info-panel remove-mat-expansion-panel-padding header-actions-panel"
  (opened)="panelOpenState = true"
  (closed)="panelOpenState = false"
  [expanded]="panelOpenState">

  <mat-expansion-panel-header>
    <mat-panel-title>
      <div class="section-header-container">
        <p class="overline grey1 semibold section-title">{{sysText.templateInfo | uppercase}}</p>
        <mat-divider class="section-header-underline" aria-hidden="true"></mat-divider>
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <!-- beside the header, not inside it (the header is a button, so controls in it can't be used from the keyboard) -->
  <!-- edit keeps focus while its dialog loads: showProgress lays the spinner over its icon, disabledInteractive keeps it
  focusable, and the guard blocks clicks -->
  @let isLoading = isLoading$ | async;
  <div ngProjectAs="mat-expansion-panel-header" class="header-actions">
    @if (templateDetails.canEditInfo) {
      <button
        mat-icon-button
        color="accent"
        [disabled]="isLoading"
        disabledInteractive
        [showProgress]="isLoading"
        [attr.aria-label]="isLoading ? sysText.loading_ariaLabel : sysText.edit_ariaLabel"
        (click)="!isLoading && editTemplateInfo()">
        <mat-icon>edit</mat-icon>
        <mat-spinner progressIndicator diameter="24" color="accent"></mat-spinner>
      </button>
    }
  </div>

  <div class="main-content">
    <div class="item-container">
      <div class="item-label">
        <p class="body2 grey2">{{sysText.templateName | titlecase}}</p>
      </div>
      <div class="item-content">
        <p class="body2 grey1 semibold">
          {{templateDetails.name}}
        </p>
      </div>
    </div>
    <div class="item-container">
      <div class="item-label">
        <p class="body2 grey2">{{sysText.emailType | titlecase}}</p>
      </div>
      <div class="item-content">
        <p class="body2 grey1 semibold">
          {{templateDetails.emailType.description}}
        </p>
      </div>
    </div>
    <div class="item-container">
      <div class="item-label">
        <p class="body2 grey2">{{sysText.owner | titlecase}}</p>
      </div>
      <div class="item-content">
        <p class="body2 grey1 semibold">
          {{ this.templateDetails.isSystem
          ? "-- " + (this.sysText.system | titlecase) + " --"
          : this.templateDetails.isStock
          ? "-- " + (this.sysText.stock | titlecase) + " --"
          : this.templateDetails.ownerEmployer }}
        </p>
      </div>
    </div>
    <div class="item-container">
      <div class="item-label">
        <p class="body2 grey2">{{sysText.allowUse | titlecase}}</p>
      </div>
      <div class="item-content">
        <p class="body2 grey1 semibold status-field">
          <app-status-icon [isEnabled]="templateDetails.allowUse"></app-status-icon> {{templateDetails.allowUse ? (sysText.enabled | titlecase) : (sysText.disabled | titlecase)}}
        </p>
      </div>
    </div>
    @if (templateDetails.showAllowEmployerAssignments) {
      <div class="item-container">
        <div class="item-label">
          <p class="body2 grey2">{{sysText.allowEmployerAssignments | titlecase}}</p>
        </div>
        <div class="item-content">
          <p class="body2 grey1 semibold status-field">
            <app-status-icon [isEnabled]="templateDetails.allowEmployerAssignments"></app-status-icon> {{templateDetails.allowEmployerAssignments ? (sysText.enabled | titlecase) : (sysText.disabled | titlecase)}}
          </p>
        </div>
      </div>
    }
  </div>
</mat-expansion-panel>